import React, { useState } from 'react';
import { translate } from '../../../services/translate';
import { IntegrationType } from '../../../schemas/cameras';
import { View } from 'react-native';
import MyAppText from '../../MyAppText';
import FilterCheckBox from '../../Filter/components/FilterCheckBox';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

type Props = {
    value: IntegrationType[];
    setValue: React.Dispatch<React.SetStateAction<IntegrationType[]>>;
    showType1: true;
} | {
    value: ('type_2' | 'type_3')[];
    setValue: React.Dispatch<React.SetStateAction<('type_2' | 'type_3')[]>>;
    showType1?: false;
};

export default function IntegrationTypesSelector({ value, setValue, showType1 }: Props) {
    const { styles } = useStyles(styleSheet);

    const [internalZIndex, setInternalZIndex] = useState<number>(0);

    const isType1 = showType1 ? value.includes('type_1') : false;
    const isType2 = value.includes('type_2');
    const isType3 = value.includes('type_3');

    function setIntegrationType(item: IntegrationType, enabled: boolean) {
        const obj = {
            type_1: item === 'type_1' ? enabled : isType1,
            type_2: item === 'type_2' ? enabled : isType2,
            type_3: item === 'type_3' ? enabled : isType3,
        } as const;

        const result = Object.entries(obj)
            .filter(([, v]) => v)
            .map(([k]) => k);

        if (showType1) {
            setValue(result as typeof value);
        } else {
            setValue(result as typeof value);
        }
    }

    return (
        <View style={[styles.section(internalZIndex)]}>
            <MyAppText style={styles.sectionTitle}>{translate('integrationType')}</MyAppText>
            <View style={[styles.checkBoxContainer]}>
                {showType1 && <FilterCheckBox
                    label={translate('type_1')}
                    value={isType1}
                    onChange={(val) => setIntegrationType('type_1', val)}
                    showTooltip
                    tooltipText={translate('type1Info')}
                    zIndex={4}
                    onTooltipHovered={(val) => val ? setInternalZIndex(9999) : setInternalZIndex(0)}
                />}
                <FilterCheckBox
                    label={translate('type_2')}
                    value={isType2}
                    onChange={(val) => setIntegrationType('type_2', val)}
                    showTooltip
                    tooltipText={translate('type2Info')}
                    zIndex={2}
                    onTooltipHovered={(val) => val ? setInternalZIndex(9999) : setInternalZIndex(0)}
                />
                <FilterCheckBox
                    label={translate('type_3')}
                    value={isType3}
                    onChange={(val) => setIntegrationType('type_3', val)}
                    showTooltip
                    tooltipText={translate('type3Info')}
                    zIndex={2}
                    onTooltipHovered={(val) => val ? setInternalZIndex(9999) : setInternalZIndex(0)}
                />
            </View>
        </View>
    );
}

const styleSheet = createStyleSheet(() => ({
    section: (zIndex: number) => {
        return {
            gap: 5,
            marginBottom: 10,
            zIndex
        };
    },
    sectionTitle: {
        fontSize: 16,
    },
    checkBoxContainer: {
        flexDirection: 'column',
        paddingLeft: 15,
        gap: 5,
    },
}));
